<template>
  <section  v-if="(showPricingForParts || content.orderable) && (hasWidgetCart || pricing.isLoaded)"
        class="level is-flex is-flex-direction-column is-align-items-flex-start">
    <div class="info-add-to-cart-grid">
      <template  v-if="displayRetail && pricing.retailAmount >= 0">
        <strong class="heading price-label"
                data-int="info-retail-title"
                data-testid="info-retail-title">
          <span v-if="!hideRetailPrice">{{ $t('retail') }}</span>
          <a v-if="showRetailEye"
             class="price-eye-toggle"
             data-int="info-retail-eye"
             @click="toggleRetailPrice">
            <span class="icon is-small has-text-link">
              <i class="fa" :class="hideRetailPrice ? 'fa-eye' : 'fa-eye-slash'" />
            </span>
          </a>
        </strong>
        <p  v-if="!hideRetailPrice"
            class="subtitle is-6"
            data-int="info-retail-price"
            data-testid="info-retail-price">
          {{ pricing.retailAmount === 0 ? $t('noPrice') : pricing.retailPrice }}
        </p>
        <span v-else />
      </template>
      <template  v-if="displayDiscounted && pricing.discountAmount >= 0">
        <strong class="heading price-label"
                data-int="info-discounted-title"
                data-testid="info-discounted-title">
          <span v-if="!hideDiscountPrice">{{ $t('discounted') }}</span>
          <a v-if="showDiscountEye"
             class="price-eye-toggle"
             data-int="info-discounted-eye"
             @click="toggleDiscountPrice">
            <span class="icon is-small has-text-link">
              <i class="fa" :class="hideDiscountPrice ? 'fa-eye' : 'fa-eye-slash'" />
            </span>
          </a>
        </strong>
        <p  v-if="!hideDiscountPrice"
            class="subtitle is-6"
            data-int="info-discounted-price"
            data-testid="info-discounted-price">
          {{ pricing.discountAmount === 0 ? $t('noPrice') : pricing.discountPrice }}
        </p>
        <span v-else />
      </template>
      <template  v-if="displayWholeSale && pricing.wholesaleAmount >= 0">
        <strong class="heading price-label"
                data-int="info-wholesale-title"
                data-testid="info-wholesale-title">
          <span v-if="!hideWholesalePrice">{{ $t('wholesale') }}</span>
          <a v-if="showWholesaleEye"
             class="price-eye-toggle"
             data-int="info-wholesale-eye"
             @click="toggleWholesalePrice">
            <span class="icon is-small has-text-link">
              <i class="fa" :class="hideWholesalePrice ? 'fa-eye' : 'fa-eye-slash'" />
            </span>
          </a>
        </strong>
        <p  v-if="!hideWholesalePrice"
            class="subtitle is-6"
            data-int="info-wholesale-price"
            data-testid="info-wholesale-price">
          {{ pricing.wholesaleAmount === 0 ? $t('noPrice') : pricing.wholesalePrice }}
        </p>
        <span v-else />
      </template>
      <template  v-if="displayAvailability && pricing.availability">
        <strong class="heading price-label"
                data-int="info-availablity-title">
          {{ $t('availability') }}
        </strong>
        <p  class="subtitle is-6 subtitle-limit"
            data-int="info-availability">
          {{ pricing.availability }}
        </p>
      </template>
      <template  v-if="displayEta && pricing.eta">
        <strong class="heading price-label"
                data-int="info-eta-title">
          {{ $t('eta') }}
        </strong>
        <p  class="subtitle is-6 subtitle-limit"
            data-int="info-eta-price">
          {{ pricing.eta }}
        </p>
      </template>

    </div>
    <div  v-if="isCartOrErpCartEnabled"
          class="add-to-cart-container">
      <add-to-cart  v-model:quantity="quantity"
                    :stack-on-small-devices="true"
                    :content="content"
                    :expanded="false"
                    :include-add-btn="true"
                    @addToCart="handleAddToCart"/>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddToCart from './AddToCart.vue'

export default {
  name: 'InfoAddToCart',
  props: {
    content: {
      type: Object,
      required: true
    },
    pricing: {
      type: Object,
      default: () => ({})
    },
    isCartOrErpCartEnabled: {
      type: Boolean,
      default: false
    },
    displayRetail: {
      type: Boolean,
      default: false
    },
    displayWholeSale: {
      type: Boolean,
      default: false
    },
    displayDiscounted: {
      type: Boolean,
      default: false
    },
    displayEta: {
      type: Boolean,
      default: false
    },
    displayAvailability: {
      type: Boolean,
      default: false
    },
    addToCartQtyBehavior: {
      type: String,
      default: ''
    },
    hasWidgetCart: Boolean,
    showPricingForParts: {
      type: Boolean,
      default: false
    }
  },
  components: {AddToCart},
  data() {
    return {
      quantity: 0,
      hideRetailPrice: false,
      hideDiscountPrice: false,
      hideWholesalePrice: false
    }
  },
  computed: {
    ...mapGetters({
      hasHidePrice: 'user/hasHidePrice',
      hasHidePriceDisabled: 'user/hasHidePriceDisabled',
      initiallyHideRetailPrice: 'user/initiallyHideRetailPrice',
      initiallyHideWholesalePrice: 'user/initiallyHideWholesalePrice',
      initiallyHideDiscountedPrice: 'user/initiallyHideDiscountedPrice'
    }),
    retailPriceLocked() {
      return !this.hasHidePrice && this.initiallyHideRetailPrice
    },
    discountPriceLocked() {
      return !this.hasHidePrice && this.initiallyHideDiscountedPrice
    },
    wholesalePriceLocked() {
      return !this.hasHidePrice && this.initiallyHideWholesalePrice
    },
    showRetailEye() {
      return !this.retailPriceLocked && (this.hasHidePrice || (this.hideRetailPrice && !this.hasHidePriceDisabled))
    },
    showDiscountEye() {
      return !this.discountPriceLocked && (this.hasHidePrice || (this.hideDiscountPrice && !this.hasHidePriceDisabled))
    },
    showWholesaleEye() {
      return !this.wholesalePriceLocked && (this.hasHidePrice || (this.hideWholesalePrice && !this.hasHidePriceDisabled))
    }
  },
  methods: {
    ...mapActions({
      addToCart: 'cart/addToCart'
    }),
    handleAddToCart(dto) {
      if (this.hasWidgetCart) {
        this.$emit('widgetAddToCart', dto)
      } else {
        this.addToCart(dto)
      }
    },
    getInitialQuantity() {
      switch (this.addToCartQtyBehavior) {
        case 'qtyZero':
          return 0
        case 'qtyFromBom':
          return this.content.quantity ? parseInt(this.content.quantity, 10) : 1
        default:
          return 1
      }
    },
    toggleRetailPrice() {
      if (!this.retailPriceLocked && (this.hasHidePrice || (this.hideRetailPrice && !this.hasHidePriceDisabled))) {
        this.hideRetailPrice = !this.hideRetailPrice
      }
    },
    toggleDiscountPrice() {
      if (!this.discountPriceLocked && (this.hasHidePrice || (this.hideDiscountPrice && !this.hasHidePriceDisabled))) {
        this.hideDiscountPrice = !this.hideDiscountPrice
      }
    },
    toggleWholesalePrice() {
      if (!this.wholesalePriceLocked && (this.hasHidePrice || (this.hideWholesalePrice && !this.hasHidePriceDisabled))) {
        this.hideWholesalePrice = !this.hideWholesalePrice
      }
    }
  },
  mounted() {
    this.quantity = this.getInitialQuantity()
    this.hideRetailPrice = this.initiallyHideRetailPrice
    this.hideDiscountPrice = this.initiallyHideDiscountedPrice
    this.hideWholesalePrice = this.initiallyHideWholesalePrice
  }
}
</script>

<style scoped>
.level {
  margin-top: 1.25rem;
  margin-bottom: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.subtitle {
  font-style: oblique;
  margin-bottom: .5rem;
  margin-left: .5rem;
  margin-right: .5rem;
}

.subtitle-limit {
  margin: auto;
  max-width: 150px;
}

.input {
  width: 4.25rem;
}

.price {
  display: block;
  text-align: center;
}

.add-to-cart-container {
  margin-top: .5rem;
}

@media only screen and (max-width: 768px) {
  .price {
    display: flex;
    text-align: left;
    justify-content: flex-start;
    margin-bottom: 0;
  }
}

.price-label {
  font-weight: 900 !important;
  -webkit-text-stroke: 0.5px currentColor; /* Adds stroke to text */
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.price-eye-toggle {
  cursor: pointer;
}

.info-add-to-cart-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: min-content !important;
  grid-gap: 0px 1rem;
}
/* Target the second column specifically */
.info-add-to-cart-grid > * {
  text-align: left !important;
  justify-self: start !important;
  margin-left: 0 !important;
  margin-right: auto !important;
  margin-bottom: .5rem !important;
  padding-bottom: 0 !important;
  line-height: 1 !important; /* Tighter line height */
}
</style>
